import { render, staticRenderFns } from "./DevCamera.vue?vue&type=template&id=8a7ba47e&lang=pug&"
import script from "./DevCamera.vue?vue&type=script&lang=ts&"
export * from "./DevCamera.vue?vue&type=script&lang=ts&"
import style0 from "./DevCamera.vue?vue&type=style&index=0&id=8a7ba47e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports